import * as Popover from '@radix-ui/react-popover';

import styles from './EllipsisOpener.module.scss';

const EllipsisButton = () => (
  <Popover.Trigger
    aria-expanded={undefined}
    aria-label="Context menu"
    className={styles.trigger}
    data-testid="contextMenuOpener"
  >
    <span className={styles.dot} />
    <span className={styles.dot} />
    <span className={styles.dot} />
  </Popover.Trigger>
);

const ContextMenu = ({
  children,
  className,
  onSelect,
}: {
  children: React.ReactNode;
  className?: string;
  onSelect?: () => void;
}) => {
  return (
    <Popover.Root>
      <div className={className}>
        <EllipsisButton />

        <Popover.Portal>
          <Popover.Content className={styles.menu} role="menu" side="left">
            <Popover.Arrow aria-hidden className={styles.arrow} />
            <Popover.Close className={styles.menuItem} data-testid="contextMenuItem" onClick={onSelect}>
              {children}
            </Popover.Close>
          </Popover.Content>
        </Popover.Portal>
      </div>
    </Popover.Root>
  );
};

export default ContextMenu;
